import { render, staticRenderFns } from "./RestaurantsMapSection.vue?vue&type=template&id=597a7d1c&"
import script from "./RestaurantsMapSection.vue?vue&type=script&lang=js&"
export * from "./RestaurantsMapSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports